import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { t } from '~/utils/narration';

const steps = [
  { en: 'Face verification', hi: 'फेस वेरिफ़िकेशन' },
  { en: 'Document verification', hi: 'डॉक्यूमेंट वेरिफ़िकेशन' },
];

export default function KycProress({ activeStep }) {

  const isStepOptional = (step) => {
    return step === 10;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          return (
            <Step key={label.en} {...stepProps}>
              <StepLabel {...labelProps}>{t(label)}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}
